import { observable } from "mobx";

export class UploadBookStore {
    @observable public uploadProgress: number = 0;
}

export const uploadBookStore = new UploadBookStore();